import { registerLocale, getName } from "i18n-iso-countries";
registerLocale(require("i18n-iso-countries/langs/en.json"));

const countryName = countryCode => countryCode === "EU" ? "Europe" : getName(countryCode, "en");

export default countryName;